import { Container } from '@components/common/Container';

import { photos } from '@assets/photos';

const STORY_INTRO =
  "Founded in Fall 2017, BHG began when George Fox (senior pastor of Bethlehem Baptist Church) and several homeschooling church members saw a need for Christian-based K-12 courses in Eastern Wake County. After a unanimous church vote, Bethlehem Homeschool Group launched under founding director Bethany Broadwell.";

const TIMELINE_ITEMS = [
  '2019: Michelle Woodard joined as Co-Director',
  '2019: Bethany transitioned to East Wake Academy; Michelle became Director',
  '2020: Beth Perkins joined as Co-Director through COVID challenges',
  '2021: Beth Perkins became Director',
  "2024: BHG Board formed with members from Bethlehem Baptist Church to support weekly operations, approve tutors, plan events, and guide the vision",
];

const STORY_CLOSING =
  "Today, BHG serves 100+ students with 12-15 Board-approved tutors offering 25-35 classes each semester.";

const SCRIPTURE_CALLOUT =
  "There was a need for more Christian-based courses in Eastern Wake County for K-12. Bethlehem Baptist Church and the surrounding community through God's grace began BHG to meet that need.";

export function OurStory() {
  return (
    <section id="our-story" className="bhg-landing-section bhg-landing-our-story">
      <Container size="lg">
        <div className="bhg-landing-our-story__header">
          <span className="bhg-landing-our-story__badge">Est. 2017</span>
          <h2 id="our-story-heading" className="bhg-landing-section__title">Our Story</h2>
        </div>

        <div className="bhg-landing-our-story__content">
          <div className="bhg-landing-our-story__narrative">
            <p className="bhg-landing-our-story__intro">{STORY_INTRO}</p>
            <ul className="bhg-landing-our-story__timeline">
              {TIMELINE_ITEMS.map((item, i) => (
                <li key={i} className="bhg-landing-our-story__timeline-item">
                  {item}
                </li>
              ))}
            </ul>
            <p className="bhg-landing-our-story__closing">{STORY_CLOSING}</p>
            <blockquote className="bhg-landing-our-story__scripture">
              {SCRIPTURE_CALLOUT}
            </blockquote>
          </div>
          <div className="bhg-landing-our-story__image-wrapper">
            <img
              src={photos.kidsBench.src}
              srcSet={photos.kidsBench.srcSet}
              sizes={photos.kidsBench.contentSizes}
              alt="Kids sitting together on a bench"
              className="bhg-landing-our-story__image"
              loading="lazy"
              decoding="async"
              width={800}
              height={500}
            />
          </div>
        </div>
      </Container>
    </section>
  );
}
